// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__p7wT6","title":"style_title__241U5"};